<template>
  <section>
    <div class="mb-2">
      <div
        v-for="(courseCondition,index) in value"
        :key="index"
        class="d-flex mb-2"
      >
        <SchemaForm
          :value="courseCondition"
          :fields="schema"
          :columns="3"
          class="flex-1 mr-2"
          @input="updateCondition(index, $event)"
        />
        <AppButton
          variant="danger"
          @click="deleteCondition(index)"
        >
          <AppIcon name="delete" />
        </AppButton>
      </div>
    </div>
    <AppButton @click="addCondition">
      <AppIcon name="add" /> Condition</AppButton>
  </section>
</template>

<script>

import FormText from '@/components/Forms/FormText'
import FormSelect from '@/components/Forms/FormSelect'
import SchemaForm from '@/components/Forms/Form'

export default {
  components: {
    SchemaForm,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    schema () {
      return {
        condition: {
          name: 'condition',
          type: FormSelect,
          placeholder: 'Set condition',
          label: 'Condition',
          config: {
            options: [
              'Age',
              'Attribute',
              'Category',
              'CourseNumber',
              'CreditType',
              'Credits',
              'Discipline',
              'GradeLetter',
              'GradeNumber',
              'GradeType',
              'Inprogress',
              'Location',
              'PassFail',
              'Passed',
              'Preregistered',
              'Resident',
              'School',
              'Section',
              'Ter',
              'Term',
              'TermType',
              'Title',
              'Transfer',
              'TransferCourse',
              'TransferSchool',
            ],
          },
        },
        comparator: {
          name: 'comparator',
          type: FormText,
          placeholder: 'Set comparator',
          label: 'Comparator',
        },
        value: {
          name: 'value',
          type: FormText,
          placeholder: 'Set value',
          label: 'Value',
        },
      }
    },
  },
  methods: {
    addCondition () {
      this.update([ ...this.value, {} ])
    },
    deleteCondition (index) {
      this.update(this.value.filter((v, i) => index !== i))
    },
    updateCondition (index, item) {
      const [ head, tail ] = [ this.value.slice(0, index), this.value.slice(index + 1) ]
      this.update([ ...head, item, ...tail ])
    },
    update (value) {
      this.$emit('input', value)
    },
  },
}
</script>
